import type { Metrics } from '@/types'

/**
 * EMCALL echo-cancel routing check. Linphone uses "PulseAudio: default
 * device", so the OS default input/output device names ("EMCALL Source
 * Micro" / "EMCALL Sink HP") reflect what a call actually uses. The
 * default can drift on its own (USB replug, PipeWire restart) back to
 * the built-in PC mic/speaker — this surfaces that everywhere in the UI.
 */

export function isEmcallDevice(name: string | null | undefined): boolean {
  return !!name && name.toUpperCase().includes('EMCALL')
}

export interface EmcallStatus {
  /** true when the input device is an EMCALL echo-cancel device */
  micOk: boolean
  /** true when the output device is an EMCALL echo-cancel device */
  outOk: boolean
  /** true when both input and output route through EMCALL */
  ok: boolean
  /** false until we have any device data (avoids false red on empty) */
  known: boolean
}

export function getEmcallStatus(metrics: Metrics | null | undefined): EmcallStatus {
  const inDev = metrics?.input_device
  const outDev = metrics?.output_device
  const known = !!(inDev || outDev)
  const micOk = isEmcallDevice(inDev)
  const outOk = isEmcallDevice(outDev)
  return { micOk, outOk, ok: micOk && outOk, known }
}

/** Short FR summary of what drifted, for badges/tooltips. */
export function emcallDriftLabel(status: EmcallStatus): string {
  if (!status.known || status.ok) return ''
  if (!status.micOk && !status.outOk) return 'Micro + sortie hors EMCALL'
  if (!status.micOk) return 'Micro hors EMCALL'
  return 'Sortie hors EMCALL'
}
